<template>
  <mi-dialog
    :model-value="modelValue"
    class="configuration-unlock-all-choices-dialog"
    @update:model-value="emitUpdateModelValue"
  >
    <!-- Title -->
    <h5 class="q-mt-md q-mb-md"> Are you sure you want to remove all locks?</h5>

    <!-- Subtitle -->
    <p class="q-mb-xl">
      This action cannot be undone.
    </p>

    <template #actions>
      <!-- Cancel button -->
      <mi-btn v-close-popup flat> Cancel </mi-btn>

      <!-- Submit button -->
      <mi-btn class="unlock-all-btn" :loading="loading" @click="handleUnlockAllChoices"> Yes, unlock all </mi-btn>
    </template>
  </mi-dialog>
</template>

<script>
  import { ref } from 'vue'

  export default {
    name: 'ConfigurationUnlockAllChoicesDialog',
    props: {
      modelValue: {
        type: Boolean,
        required: true
      },
      unlockAllChoices: {
        type: Function,
        required: true
      }
    },
    emits: ['update:model-value'],
    setup(props, { emit }) {
      const loading = ref(false)

      const emitUpdateModelValue = (value = false) => {
        emit('update:model-value', value)
      }

      const handleUnlockAllChoices = async () => {
        loading.value = true
        await props.unlockAllChoices()
        loading.value = false
        emitUpdateModelValue()
      }

      return {
        handleUnlockAllChoices,
        emitUpdateModelValue,
        loading
      }
    }
  }
</script>

<style lang="scss">
  .configuration-unlock-all-choices-dialog {
    .q-dialog__inner > .mi-card {
      width: 682px;
      max-width: 682px;
      min-width: 682px;
      height: 293px;
    }

    h5 {
      font-size: 28px;
    }

    .mi-btn {
      font-size: 18px;
      height: 50px;
    }

    .unlock-all-btn {
      width: 167px;
    }

    .q-card__section:nth-child(2) {
      height: 160px;
    }
  }

  @media (max-width: $mi-responsive-large-width) {
    .configuration-unlock-all-choices-dialog {
      .q-dialog__inner > .mi-card {
        width: 682px;
        max-width: 682px;
        height: 293px;
      }
    }
  }

  @media (max-width: $mi-responsive-medium-width) {
    .configuration-unlock-all-choices-dialog {
      .q-dialog__inner > .mi-card {
        width: 682px;
        max-width: 682px;
        height: 293px;
      }
    }
  }
</style>
